import { Store } from "../../../_node_modules/@jwplayer/fe-common/module/store/index.js";

//#region ../base/upload/manager.ts
const DEFAULT_SETTINGS = {
	startNextInQueueOn: [
		"finished",
		"aborted",
		"failed"
	],
	maxSimultaneousUploads: 1
};
function reduceStates(uploads) {
	return uploads.reduce((acc, upload) => {
		acc[upload.getState().state]++;
		if (upload.getState().pollAssetState === "active") acc.pollingAsset++;
		return acc;
	}, {
		aborted: 0,
		active: 0,
		failed: 0,
		finished: 0,
		idle: 0,
		paused: 0,
		queued: 0,
		pollingAsset: 0
	});
}
function calcProgress(uploads) {
	if (uploads.length === 0) return 0;
	const ignoreStates = [
		"failed",
		"aborted",
		"idle"
	];
	const count = uploads.filter((u) => !ignoreStates.includes(u.getState().state)).length;
	if (count === 0) return 0;
	return uploads.reduce((acc, upload) => {
		if (ignoreStates.includes(upload.getState().state)) return acc;
		return acc + upload.getState().progress;
	}, 0) / count;
}
const sortByIndex = (a, b) => {
	return a.index - b.index;
};
var UploadManager = class {
	store = new Store({
		uploads: [],
		states: reduceStates([]),
		progress: calcProgress([])
	});
	subscribe = this.store.subscribe.bind(this.store);
	getState = this.store.getState.bind(this.store);
	_settings = structuredClone(DEFAULT_SETTINGS);
	_unsub = /* @__PURE__ */ new Map();
	add(upload) {
		const unsub = upload.subscribe((s) => s, () => {
			this.store.setState((s) => {
				s.uploads = s.uploads.map((u) => u).sort(sortByIndex);
				s.states = reduceStates(s.uploads);
				s.progress = calcProgress(s.uploads);
			});
		});
		this._unsub.set(upload, unsub);
		this.store.setState((s) => {
			s.uploads.push(upload);
		});
	}
	remove(upload) {
		this._unsub.get(upload)?.();
		this.store.setState((s) => {
			s.uploads = s.uploads.filter((u) => u !== upload).sort(sortByIndex);
			s.states = reduceStates(s.uploads);
			s.progress = calcProgress(s.uploads);
		});
	}
	resetSettings() {
		this._settings = structuredClone(DEFAULT_SETTINGS);
	}
	updateSettings(fn) {
		this._settings = fn(this._settings);
	}
	getSettings() {
		return structuredClone(this._settings);
	}
	allUploads = {
		get: () => {
			return this.store.getState().uploads;
		},
		abort: () => {
			const uploads = this.allUploads.get();
			for (const upload of uploads) upload.abort();
		},
		remove: () => {
			this.allUploads.get().map((u) => {
				u.remove();
			});
		}
	};
	canStartUpload() {
		if (this.allUploads.get().filter((s) => s.getState().state === "active").length >= this._settings.maxSimultaneousUploads) return false;
		return true;
	}
	startNextQueuedUpload(force = false) {
		const queuedUpload = this.allUploads.get().find((u) => u.getState().state === "queued");
		if (queuedUpload) queuedUpload.start(force);
	}
	getPublicApi() {
		return {
			allUploads: this.allUploads,
			subscribe: this.subscribe,
			getState: () => this.getState(),
			startNextQueuedUpload: this.startNextQueuedUpload,
			canStartUpload: this.canStartUpload,
			getSettings: this.getSettings,
			updateSettings: this.updateSettings,
			resetSettings: this.resetSettings
		};
	}
};
const uploadManager = new UploadManager();
const getTypedUploadManager = () => {
	return uploadManager;
};

//#endregion
export { getTypedUploadManager, uploadManager };